import { ability, defineRulesFor } from "@/plugins/ability";
import Api from '@/api/index'

const Users = {
  namespaced: true,
  state: {
    one_user: null,
    user: null,
    all_users: []
  },
  mutations: {
    setCurrentUser(state, data) {
      state.user = data;
    },
    login(state, user) {
      // automatizada na configuração de parse e fetch user - plugins/vue-auth
      state.user = user;
      // ability.update(user.rules);
    },
    logout(state) {
      state.user = null;
      ability.update([]);
    },
    setAllUsers(state, users) {
      state.all_users = [...users];
    },
    pushToAllUsers(state, user) {
      state.all_users.push({...user});  
    },
    deleteUser(state, user) {
      let idx = state.all_users.findIndex(u => u.id == user.id)
      state.all_users.splice(idx, 1)
    }
  },

  actions: {
    getCurrentUser(context, data) {
      context.commit("setCurrentUser", data);
      // if (data) context.commit("setTokenData", localStorage.auth_token_default);
    },
    index({commit}) {
      Api.User.index().then(r => r.data).then(users => {
        commit('setAllUsers', users);
      }).catch(error => {
        throw Error(error);
      })
    },
    async create({commit, dispatch}, user) {
      // let new_user = {
      //   ...user,
      //   password: '9876543210',
      //   password_confirmation: '9876543210'
      // };
      let notification = {};
      await Api.User.create({...user}).then(r => r.data).then(r => {
        // let update_password = {
        //   ...r,
        //   password: '9876543210',
        //   password_confirmation: '9876543210'
        // }
        // Api.User.update(update_password)
        notification.type = 'success';
        notification.msg = 'Feito com sucesso';
        commit('pushToAllUsers', r);
      }).catch(error => {
        notification.type = 'error';
        notification.msg = `Erro: ${error}`;
        throw Error(error);
      }).finally(() => {
        dispatch('Notification/add', notification, {root: true});
      })
    },
    delete({commit, dispatch}, user) {
      let notification = {};
      Api.User.delete(user.id).then(r => r.data).then(r => {
        notification.type = 'success';
        notification.msg = 'Feito com sucesso';
        commit('deleteUser', r);
      }).catch(error => {
        notification.type = 'error';
        notification.msg = `Erro: ${error}`;
        throw Error(error);
      }).finally(() => {
        dispatch('Notification/add', notification, {root: true});
      })
    }
  }
};

export default Users;
